/**
 * Info-tooltip copy for Chat WebSocket agent arguments. Centralized so the
 * direct-mode, HTTP-first, behavior, handshake, and text-format field groups
 * stay in sync, mirroring WEBSOCKET_TOOLTIPS on the voice WebSocket form.
 */
export const CHAT_WEBSOCKET_TOOLTIPS = {
  endpoint:
    "The wss:// URL Coval connects to in direct mode. Must be a secure WebSocket URL; ws://, http://, and https:// are rejected.",
  initializationJson:
    "Optional JSON object Coval sends to the WebSocket immediately after connecting, used to configure the session on your agent's side. No message is sent if left empty. Supports {{simulation_output_id}} (alias: {{simulation_id}}), {{test_case.*}}, {{agent.*}}, {{run_metadata.*}}, and {{sim_wrapper.*}}.",
  authorizationHeader:
    "Auth value sent on the WebSocket connection, e.g. 'Bearer <token>'. Use 'X-API-Key <key>' for API-key auth. Don't pass JSON here — use Custom Headers.",
  customHeaders:
    "Additional WebSocket connection headers as a JSON object, e.g. {'X-Coval-Simulation-Id': '{{simulation_id}}'}. Supports {{simulation_output_id}} (alias: {{simulation_id}}), {{test_case.*}}, {{agent.*}}, {{run_metadata.*}}, and {{sim_wrapper.*}}.",
  httpUrl:
    "The https:// setup endpoint Coval calls first to provision a session before opening the WebSocket.",
  httpMethod: "HTTP method for the setup request (default: POST).",
  httpRequestBody: "JSON body sent with the HTTP setup request.",
  httpHeaders:
    "JSON object of headers for the HTTP setup request. Separate from the WebSocket connection auth.",
  websocketUrlResponsePath:
    "Dot-notation path to the WebSocket URL in the setup response, e.g. 'data.websocket_url'.",
  initialMessage:
    "First message Coval sends to the agent after connection and handshake. Leave empty to skip.",
  messageCoalesceTimeout:
    "Quiet period (seconds) Coval waits after the last received message before batching them into one response. Set to 0 to deliver each message immediately (default: 2.0).",
  readyMessageType:
    "Message type value that signals the agent is ready for conversation messages. Leave empty to skip the handshake wait.",
  handshakeTimeout:
    "Seconds Coval waits for the ready message before timing out (default: 30).",
  sendMessageTemplate:
    "JSON template for outbound messages. Must contain the {{message}} placeholder, which is replaced with the message text. Defaults to a {type, text} shape.",
  receiveMessageTextPath:
    "Dot-notation path to the text content in inbound messages (default: 'text').",
  receiveMessageTypePath:
    "Dot-notation path to the field that names the message kind in inbound messages (default: 'type').",
  textMessageTypeValues:
    "Comma-separated message type values that indicate text content (default: 'message').",
  agentDisconnectMessageType:
    "Message type that signals the agent has ended the session. Leave empty to disable.",
  receiveMessageDirectionPath:
    "Dot-notation path to the direction field in inbound messages. Pair it with the outbound value to skip echoed messages. Leave empty to process all messages.",
  outboundDirectionValue:
    "The direction value that marks an agent-to-user message, e.g. 'outbound'. Only messages matching this value are processed when a direction path is set.",
} as const
